import React from 'react';
import { MdDelete } from 'react-icons/md';
import { PapProgressStatus, PapSyncStatus } from '@ydistri/api-sdk';
import { YPICK_LABEL } from '../../../components/global/_constants';

/**
 * Descriptor for the Remove from Y'pick action that is used in multiple places
 * so the icon, label and other behavior is defined only once
 */
export const removeFromYPickAction = {
  label: `Remove from ${YPICK_LABEL}`,
  icon: <MdDelete />,
  disabledReason: (
    papDbSyncStatus: PapSyncStatus,
    papResultCalculationProgressStatus: PapProgressStatus,
  ): string | undefined => {
    if (papResultCalculationProgressStatus !== PapProgressStatus.NotStarted)
      return 'Picking has already started';
    if (papDbSyncStatus === PapSyncStatus.Syncing) return `Export to ${YPICK_LABEL} is in progress`;
    return undefined;
  },
  isDisabled: (
    papDbSyncStatus: PapSyncStatus,
    papResultCalculationProgressStatus: PapProgressStatus,
  ): boolean =>
    removeFromYPickAction.disabledReason(papDbSyncStatus, papResultCalculationProgressStatus) !==
    undefined,
};
